export enum InvoiceTerms {
	'NET_15_DAYS' = 'NET_15_DAYS',
	'NET_30_DAYS' = 'NET_30_DAYS',
	'NET_45_DAYS' = 'NET_45_DAYS',
	'NET_60_DAYS' = 'NET_60_DAYS',
	'NET_90_DAYS' = 'NET_90_DAYS',
	'NET_120_DAYS' = 'NET_120_DAYS',
	'CUSTOM' = 'CUSTOM',
}
export const InvoiceTermsToDisplay: { [K in keyof typeof InvoiceTerms]: string } = {
	NET_15_DAYS: 'Net 15 Days',
	NET_30_DAYS: 'Net 30 Days',
	NET_45_DAYS: 'Net 45 Days',
	NET_60_DAYS: 'Net 60 Days',
	NET_90_DAYS: 'Net 90 Days',
	NET_120_DAYS: 'Net 120 Days',
	CUSTOM: 'CUSTOM',
};

export const dueDateObj = {
  NET_15_DAYS: 15,
  NET_30_DAYS: 30,
  NET_45_DAYS: 45,
  NET_60_DAYS: 60,
  NET_90_DAYS: 90,
  NET_120_DAYS: 120,
  "Net 15 Days": 15,
  "Net 30 Days": 30,
  "Net 45 Days": 45,
  "Net 60 Days": 60,
  "Net 90 Days": 90,
  "Net 120 Days": 120,
};
